import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleResolvedChallengeParameter } from '~/boggle/config/challenges/modTypes'

export function formatResolvedBoardDistributionDisplayFromDefinition(
  definition: BoggleChallengeBoardDistributionDefinition,
  parameters: Record<string, BoggleResolvedChallengeParameter>,
) {
  return (
    definition.formatResolvedDisplay?.({
      parameters,
    }) ?? {
      description: definition.description,
      name: definition.name,
      shortLabel: definition.shortLabel,
    }
  )
}
